import * as React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel
} from "@mui/material";
import { useInput, InputHelperText  } from "react-admin";
import { MuiColorInput } from 'mui-color-input'
import { FieldTitle } from 'ra-core';
import clsx from 'clsx';

export const ColorInput = (props) => {
  const {
    label,
    className,
    validate,
    helperText,
    source,
    resource,
    defaultValue,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error, invalid, isTouched },
    formState: { isSubmitted },
    isRequired,
  } = useInput({ ...props, source, resource, defaultValue, validate });

  const renderHelperText =
  helperText !== false || ((isTouched || isSubmitted) && invalid);

  return (
    <>
      <FormControl
        required={isRequired}
        size="small"
      >
        <MuiColorInput
          {...field}
          format="hex"
          className={clsx('ra-input', `ra-input-${source}`, className)}
          size="small"
          type="outlined"
          required={isRequired}
          error={(isTouched || isSubmitted) && invalid}
          helperText={
            renderHelperText ? (
                <InputHelperText
                    touched={isTouched || isSubmitted}
                    error={error?.message}
                    helperText={helperText}
                />
            ) : null
          }
          label={
            <FieldTitle
                label={label}
                source={source}
                resource={resource}
                isRequired={isRequired}
            />
          }
          {...rest}
        ></MuiColorInput>
      </FormControl>
    </>
  );
};
